class NSSCarousel extends HTMLElement {
    constructor() {
        super();
        this.debug = false;
        this.swiper = null;
        this.selectors = {
            pdpVideo: '.js-nss-pdp-video',
            heroVideo: '.js-video-hero',
            videoCard: 'nss-video-card',
            swiperContainer: '.swiper',
            settings: '#swiper-settings',
            slides: '.swiper-slide',
            navNext: '.nss-carousel-button-next',
            navPrev: '.nss-carousel-button-prev',
            pagination: '.swiper-pagination'
        };

        this.handleEditorBound = this.handleEditorEvent.bind(this);
    }

    connectedCallback() {
        this.initCarousel();


        // Shopify Editor Listeners
        const events = [`shopify:section:load`, `shopify:block:select` ];
        events.forEach(ev => this.addEventListener(ev, this.handleEditorBound));
    }

    /**
     * STOPS Manual Video Cards (The ones with sound)
     */
    stopAllManualVideos() {
        const playingCards = this.querySelectorAll(`${this.selectors.videoCard}.is-video-playing`);
        playingCards.forEach(card => {
            const video = card.querySelector('video');
            if (video) video.pause();
            card.classList.remove('nss-video-playing');
        });
    }

    /**
     * Handle Muted Background PDP Videos (Autoplay)
     */
    handlePdpVideos(swiper) {
        // Pause all background pdp videos
        this.querySelectorAll(this.selectors.pdpVideo).forEach(v => {
            v.pause();
            v.muted = true;
        });

        // Play only in active slide
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activePdpVideo = activeSlide?.querySelector(this.selectors.pdpVideo);
        if (activePdpVideo) {
            activePdpVideo.muted = true;
            activePdpVideo.play().catch(() => {});
        }
    }

    initCarousel() {
        const self = this;
        const container = this.querySelector(this.selectors.swiperContainer);
        const settingsEl = this.querySelector(this.selectors.settings);
        if (!container || !settingsEl) return;

        const settings = JSON.parse(settingsEl.textContent);

        function setVideoProgress(video, progressEl){
            if (!video || !progressEl) return;

            function update(){
                if (!video.duration) return;

                const percent = (video.currentTime / video.duration) * 100;
                self.style.setProperty('--progress', percent + '%');
            }

            video.addEventListener('timeupdate', update);

            video.onended = () => {
                self.style.setProperty('--progress', '100%');
            };
        }
        const presets = {
            on: {
                init: function () {
                    self.handlePdpVideos(this);
                    const activeSlide = this.slides[this.activeIndex];
                    if (!activeSlide) return;
                    const video = activeSlide.querySelector('.js-video-hero');
                    const progress = self;
                    if (!video) {
                        progress.style.setProperty('--progress','100%');
                        return;
                    }
                    video.muted = true;
                    video.currentTime = 0;
                    video.play().catch(()=>{});
                    setVideoProgress(video, progress);
                    video.onended = () => {
                        if (this.isEnd) this.slideTo(0);
                        else this.slideNext();
                    };
                },
                slideChangeTransitionStart: function () {
                    // REQUIREMENT: As soon as the slide starts moving, kill all manual videos with sound
                    self.stopAllManualVideos();

                    // Update the muted background videos
                    self.handlePdpVideos(this);

                    // Hero Progress Reset
                    self.style.setProperty('--progress', '0%');
                },
                slideChangeTransitionEnd: function() {
                    // Hero Progress Playback Logic
                    const activeSlide = this.slides[this.activeIndex];
                    const hero = activeSlide?.querySelector(self.selectors.heroVideo);
                    if (hero) {
                        hero.muted = true;
                        hero.play().catch(() => {});
                    } else {
                        self.style.setProperty('--progress', '100%');
                    }
                },
                slideChange: function () {
                    self.style.setProperty('--progress','0%');
                    self.querySelectorAll('.js-video-hero').forEach(v=>{
                        v.pause();
                        v.currentTime = 0;
                        v.onended = null;
                    });
                    const activeSlide = this.slides[this.activeIndex];
                    if (!activeSlide) return;
                    const video = activeSlide.querySelector('.js-video-hero');
                    const progress = self;
                    if (!video) {
                        progress.style.setProperty('--progress','100%');
                        return;
                    }
                    video.muted = true;
                    video.play().catch(()=>{});
                    setVideoProgress(video, progress);
                    video.onended = () => {
                        if (this.isEnd) this.slideTo(0);
                        else this.slideNext();
                    };
                }

            }
        };

        const config = Object.assign({
            navigation: { nextEl: this.selectors.navNext, prevEl: this.selectors.navPrev },
            pagination: { el: this.selectors.pagination, clickable: true },
        }, settings, presets);

        this.swiper = new Swiper(container, config);

        // Hover/Open logic
        this.querySelectorAll(this.selectors.slides).forEach(slide => {
            slide.addEventListener("mouseenter", () => slide.classList.add('is-hover'));
            slide.addEventListener("mouseleave", () => slide.classList.remove('is-hover'));
            slide.addEventListener("click", (e) => {
                if (e.target.closest('button') || e.target.closest(this.selectors.videoCard)) return;
                slide.classList.toggle('is-open');
                setTimeout(() => this.swiper?.update(), 400);
            });
        });
    }

    handleEditorEvent(e) {
        if (e.type === 'shopify:section:load') this.initCarousel();
        if (e.type === 'shopify:block:select' && this.swiper) {
            const el = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
            const slide = el?.closest(this.selectors.slides);
            if (slide) {
                const idx = [...this.querySelectorAll(this.selectors.slides)].indexOf(slide);
                this.swiper.slideTo(idx);
            }
        }
    }
}

if (!customElements.get('nss-carousel')) {
    customElements.define('nss-carousel', NSSCarousel);
}